<div class="mb-2 message-text" [innerHTML]="data.message | async"></div>
<div class="mt-2 d-flex justify-content-end">
  <button type="button" mat-raised-button color="primary" class="me-3" (click)="ok()">
    {{ data.primaryButtonLabel | async }}
  </button>
  <button color="accent" mat-raised-button (click)="cancel()">
    {{ data.secondaryButtonLabel | async }}
  </button>
</div>
